import styled from '@emotion/styled';
import { fromThemeColors, palette, ThemeColor } from '@sharefiledev/flow-web';

const width = '100%';
const borderColor = fromThemeColors(ThemeColor.border)({ theme: {} });

export const FieldsSectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	overflow: hidden;
`;

export const Fields = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0;
	gap: 8px;
	width: ${width};
`;

export const Title = styled.span`
	font-size: 16px;
	margin-bottom: 2px;
`;

export const Field = styled.div<{ isSelected: boolean; optionColor: string | undefined }>(
	({ optionColor, isSelected }) => `
	box-sizing: border-box;
	display: flex;
	align-items: center;
	padding: 12px 16px;
	gap: 16px;
	isolation: isolate;
	cursor: pointer;
	user-select: none;
	
	width: ${width};
	height: 48px;
	
	background: ${fromThemeColors(ThemeColor.inputBackground)};
	
	border:  ${isSelected ? `2px solid ${optionColor}` : `1px solid ${borderColor}`};
	border-radius: 8px;

	
	&:hover{
		background-color: #BCC0C2;
	}
`
);

export const FieldLabel = styled.p<{ optionColor?: string | undefined }>(
	({ optionColor: color }) => `
	color: ${color};
	font-size: 14px;
`
);

export const Description = styled.span`
	color: ${fromThemeColors(ThemeColor.metadataText)};
	line-height: 24px;
	margin: 4px 0px 16px;
`;

export const PlaceHolderComponent = styled(Field)<{
	showPlaceHolderComponent: boolean;
	isOverDocument?: boolean;
}>`
	display: ${props => (props.showPlaceHolderComponent ? 'flex' : 'none')};
	position: fixed;
	top: 0;
	left: 0;
	cursor: grabbing;
	width: 48px;
	height: 48px;
	flex-direction: row;
	background: ${palette.grey100};
	z-index: 1500;
	justify-content: center;
	pointer-events: none;

	${props =>
		props.isOverDocument &&
		`
		opacity: 0.7;
		border: 2px dashed ${palette.blue500};
	`}
`;
